import * as z from 'zod';

import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';
import { statusQuerySchema } from '@/_schemas/status-input';

export const departmentQuerySchemaBase = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string().nullable(),
  status: statusQuerySchema,
});
export type DepartmentQuerySchemaBase = z.infer<typeof departmentQuerySchemaBase>;

export const departmentQuerySchema = departmentQuerySchemaBase.extend({
  parent_id: z.number().nullable(),
  parent: departmentQuerySchemaBase.nullable(),
  children: z.array(departmentQuerySchemaBase).nullable(),
});

export type DepartmentQuerySchema = z.infer<typeof departmentQuerySchema>;

export const departmentQueryAllSchema = paginatedResponseSchema(departmentQuerySchema);
export type DepartmentQueryAllSchema = z.infer<typeof departmentQueryAllSchema>;
